'use client';

import { c as _c } from "react/compiler-runtime";
import { usePathname } from 'next/navigation';
import { Breadcrumb } from '@/modules/shared/components/breadcrumb';
import type { Route } from 'next';
interface BuilderBreadcrumbProps {
  networkSlug: string;
  builderSlug: string;
  networkName: string;
  builderName: string;
}
function BuilderBreadcrumb(t0) {
  const $ = _c(19);
  const {
    networkName,
    networkSlug,
    builderName,
    builderSlug
  } = t0;
  const pathname = usePathname();
  let t1;
  if ($[0] !== pathname) {
    t1 = pathname.includes("budget-statements");
    $[0] = pathname;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const isBudgetStatements = t1;
  const t2 = `/network/${networkSlug}` as Route;
  let t3;
  if ($[2] !== networkName || $[3] !== t2) {
    t3 = {
      label: networkName,
      href: t2
    };
    $[2] = networkName;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const t4 = `/network/${networkSlug}/builders` as Route;
  let t5;
  if ($[5] !== t4) {
    t5 = {
      label: "Builders",
      href: t4
    };
    $[5] = t4;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  const t6 = `/network/${networkSlug}/builders/${builderSlug}` as Route;
  let t7;
  if ($[7] !== builderName || $[8] !== t6) {
    t7 = {
      label: builderName,
      href: t6
    };
    $[7] = builderName;
    $[8] = t6;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== builderSlug || $[11] !== isBudgetStatements || $[12] !== networkSlug || $[13] !== t3 || $[14] !== t5 || $[15] !== t7) {
    const items = [t3, t5, t7];
    if (isBudgetStatements) {
      const t9 = `/network/${networkSlug}/builders/${builderSlug}/budget-statements` as Route;
      let t10;
      if ($[17] !== t9) {
        t10 = {
          label: "Budget Statements",
          href: t9
        };
        $[17] = t9;
        $[18] = t10;
      } else {
        t10 = $[18];
      }
      items.push(t10);
    }
    t8 = <div><Breadcrumb items={items} /></div>;
    $[10] = builderSlug;
    $[11] = isBudgetStatements;
    $[12] = networkSlug;
    $[13] = t3;
    $[14] = t5;
    $[15] = t7;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  return t8;
}
export { BuilderBreadcrumb };